function TagFilterAction(el) {
    this.el = el;
    this.count_el = this.el.querySelector('.action__btn-ctn');
    this.text = this.el.querySelector('.action__btn-text');
    if (!this.count_el || !this.text) {
        throw 'Нет всех компонентов';
    }
    this.name = 'tags';
    this.state = [];
    this.popup_form = $('#tag');
    this.labels = this.popup_form.find('input[type="checkbox"]').toArray().reduce(function (acc, item) {
        acc[item.value] = item.labels[0].innerText.trim();
        return acc;
    }, {});

}

TagFilterAction.prototype.render = function () {
    if (this.state.length) {
        this.el.classList.add('active');
        var self = this;
        var items = this.state;
        var count = 0;
        if (this.state.length > 3) {
            items = this.state.slice(0, 3);
            count = this.state.length - 3;
        }

        var text = items.reduce(function (acc, item) {
            if (acc === '') {
                acc = self.labels[item];
            } else {
                acc += ', ' + self.labels[item];
            }
            return acc;
        }, '');
        if (count > 0) {
            text += ' ...';
            this.count_el.innerText = '+' + count;
            this.count_el.classList.add('active');
        } else {
            this.count_el.classList.remove('active');
        }
        this.text.innerText = text;
    } else {
        this.el.classList.remove('active');
        this.count_el.classList.remove('active');
        this.text.innerText = 'Фильтр по тегам';
        if (this.popup_form.length) {
            this.popup_form[0].reset();
            $(this.popup_form[0]).find('.js-filter-search-input').trigger('input')
            this.popup_form.find('input').removeAttr('checked');
        }
    }
};

TagFilterAction.prototype.setData = function (state) {
    this.state = state.hasOwnProperty(this.name) && state[this.name] ? state[this.name] : [];
};
